import React from "react";
import {observable, computed, reaction, extendObservable} from "mobx";
import _ from 'lodash';
import { getByAtribute } from "../../../utils/formatar";
import UsuarioService from "../../../services/UsuarioService";
import EmpregadoService from "../../../services/EmpregadoService";
import ETTService from "../../../services/ETTService";
import {motivoContratacaoEnum} from "../../../utils/enums";
import JustificativaContratacaoService from "../../../services/JustificativaContratacaoService";
import LocalTrabalhoService from "../../../services/LocalAcessoService";
import CargoService from "../../../services/CargoService";
import ProdutoService from "../../../services/ProdutoService";
import AreaService from "../../../services/AreaService";
import SolicitacaoService from "../../../services/SolicitacaoService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import GDVService from "../../../services/GDVService";
import store from "../../../stores";
import moment from "moment";
import TarefaService from "../../../services/TarefaService";
import MotService from "../../../services/MOTService";
import ParametroGeralService from "../../../services/ParametroGeralService";
import * as shortid from "shortid";
import {Alerta} from "../../comum/components/Alerta";
import LotacaoService from "../../../services/LotacaoService";
import DadosSocService from "../../../services/DadosSocService";
import FluxoService from "../../../services/FluxoService";

export default class SolicitacaoContratacaoStore {
    @observable solicitacao;
    @observable justificativasContratacao;
    @observable locaisTrabalho;
    @observable cargos;
    @observable motivosContratacao;
    @observable produtos;
    @observable fatosGeradores;
    @observable usuarioLogado;
    @observable observacoes;
    @observable gdvId;
    @observable isSolicitacaoDeAjuste;
    @observable isSolicitacaoDeClonagem;
    @observable taskAjustId;
    @observable definicaoTarefaId;
    @observable definicaoFluxoId;
    @observable comentarios;
    @observable tarefasFluxo;
    @observable dataInicioValidacao;
    @observable dataTerminoValidacao;
    @observable empregadosFiltrados;
    @observable lotacoesFiltradas;
    @observable loadingCpfIndicacao;
    @observable cargoSelecionado;
    @observable gestorSelecionado;
    @observable habilitarSalvarRascunho;
    @observable isLoadingArDebito;
    @observable gestoresArDebito;
    @observable carregandoCargo;
    @observable loadingGestorArDebito;
    @observable parametros;
    @observable loadingEtts;
    @observable etts;
    @observable gestorARError;
    @observable existeCargoNoPcp;
    @observable empresasGlobo;
    @observable lotacoes;
    @observable todosAprovadores;
    @observable obterCargoSubstituido;
    @observable cargoNaoPresente;
    @observable idProdutoSelecionado;
    @observable dadosSoc;
    @observable alertaGestorSolicitante;

    @observable tipoEmailContratacao;

    @observable targetCentroCustoDebito;
    @observable isLoadingProduto;

    constructor(loginStore, modalStore, formStore, validacaoStore, tituloPaginaStore, loadingPanelStore, formErrorsStore) {
        this.formErrorsStore                        = formErrorsStore;
        this.loadingPanelStore                      = loadingPanelStore;
        this.tituloPaginaStore                      = tituloPaginaStore;
        this.modalStore                             = modalStore;
        this.formStore                              = formStore;
        this.validacaoStore                         = validacaoStore;
        this.loginStore                             = loginStore;
        this.path                                   = null;
        this.carregandoCargo                        = false;
        this.loadingGestorArDebito                  = false;
        this.gestorARError                          = [];
        this.existeCargoNoPcp                       = [];
        this.codigoErro                             = null;
        this.isLoadingArDebito                      = false;
        this.gestorFiltrado                         = null;
        this.empregadosFiltrados                    = [];
        this.cargoSelecionado                          = {};
        this.etts                                   = [];
        this.gestoresArDebito                       = null;
        this.loadingEtts                            = false;
        this.resetSolicitacao();
        this.observacoes                            = "";
        this.isSolicitacaoDeAjuste                  = false;
        this.isSolicitacaoDeClonagem                = false;
        this.taskAjustId                            = null;
        this.definicaoTarefaId                      = null;
        this.definicaoFluxoId                       = null;
        this.gestorSelecionado                      = null;
        this.parametros                             = null;
        this.cargos                                 = [];
        this.obterCargoSubstituido                  = false;
        this.cargoNaoPresente                       = false;
        this.dadosSoc                               = {}

        this.comentarios                            = [];
        this.locaisTrabalho                         = [];
        this.tarefasFluxo                           = [];
        this.empresasGlobo                          = [];
        this.lotacoes                               = [];
        this.motivosContratacao                     = [];
        this.justificativasContratacao              = [];
        this.produtos                               = [];
        this.fatosGeradores                         = [];
        this.gdvId                                  = null;
        this.loadingCpfIndicacao                    = [];
        this.habilitarSalvarRascunho                = true;
        this.todosAprovadores                       = [];
        this.idProdutoSelecionado                   = undefined;
        this.tipoEmailContratacao = null;
        this.isLoadingProduto = false;
        this.alertaGestorSolicitante = "";

        this.motService                             = new MotService();
        this.empregadoService                       = new EmpregadoService();
        this.justificativaContratacaoService        = new JustificativaContratacaoService();
        this.localTrabalhoService                     = new LocalTrabalhoService();
        this.cargoService                           = new CargoService();
        this.produtoService                         = new ProdutoService();
        this.areaService                            = new AreaService();
        this.solicitacaoService                     = new SolicitacaoService();
        this.usuarioService                         = new UsuarioService();
        this.gdvService                             = new GDVService();
        this.tarefaService                          = new TarefaService();
        this.empresaGloboService                    = new EmpresaGloboService();
        this.parametroGeralService                  = new ParametroGeralService();
        this.ettService                             = new ETTService();
        this.lotacaoService                         = new LotacaoService();
        this.dadosSocService                        = new DadosSocService();
        this.fluxoService                           = new FluxoService();

        this.filtrarCargos = _.debounce(this._filtrarCargos, 1000);
        this.filtrarEmpregados = _.debounce(this._filtrarEmpregados, 1000);
        this.filtrarGestoresSolicitantes = _.debounce(this._filtrarGestoresSolicitantes, 1000);
        this.filtrarAprovadoresExtra = _.debounce(this._filtrarAprovadoresExtra, 1000);
        
        this.tiposEmailContratacao = [
            {
                value: "0", label: 'Não Necessário',
                description: 'A MOT não precisará de nenhum acesso a sistemas, e-mail ou equipamento da empresa.'
            },
            {
                value: "1", label: 'Acesso a Sistemas (Navegador)',
                description: 'A MOT receberá um login para acessar sistemas corporativos e o Microsoft 365 (Office) exclusivamente pelo navegador de internet. Não inclui instalação em máquina pessoal.'
            },
            {
                value: "2", label: 'Desktop Corporativo',
                description: 'Será disponibilizado um computador de mesa (desktop) da empresa, com todos os acessos necessários, incluindo e-mail e pacote Microsoft 365 instalado.'
            },
            {
                value: "3", label: 'Notebook Corporativo',
                description: 'Será disponibilizado um notebook da empresa, com todos os acessos necessários, incluindo e-mail e pacote Microsoft 365 instalado.'
            },
        ];
        

        this.targetCentroCustoDebito = null;


        reaction(
            () => store.$stores.loginStore.usuarioLogado,
            usuarioLogado => {
                if (!this.path || this.path === "/nova-solicitacao-contratacao") {
                    this.getUsuarioLogado();
                }
            }
        );

        reaction(
            () => this.solicitacao.gestorAreaDebito,
            gestorAr => {
                if (!gestorAr) {
                    this.gestorARError = [];
                }
            }
        );


        reaction(
            () => this.solicitacao.motivoContratacao,
            motivo => {
                if (motivo) {
                    this.justificativaContratacaoService.listByMotivo(motivo).then(response => {
                        this.justificativasContratacao = response.data;
                        this.resetJustificativa();
                    }).catch(error => {
                        this.formErrorsStore.addError(error);
                        console.log(error);
                    });
                } else {
                    this.justificativasContratacao = [];
                    this.resetJustificativa();
                }
            }
        );

        reaction(
            () => this.solicitacao.justificativaContratacao,
            justificativa => {
                this.isLoadingProduto = true;
                if (justificativa && justificativa.id) {
                    this.isLoadingProduto = true;
                    if (_.get(justificativa, "justificativaAlocavel") !== "NAO") {
                        this.produtoService.listByJustificativa(justificativa.id)
                            .then(response =>
                            {
                                this.produtos = response.data;
                                this.resetProduto();
                            })
                            .catch(error =>
                            {
                                this.formErrorsStore.addError(error);
                            });
                        //}
                    } else {
                        this.produtos = [];
                        this.resetProduto();
                    }
                    if (_.get(justificativa, "possuiFatoGerador")) {
                        this.produtoService.listFatosGeradores().then(response => {
                            this.fatosGeradores = response.data;
                            this.resetFatoGerador();
                        }).catch(error => {
                            this.formErrorsStore.addError(error);
                            console.log(error);
                        });
                    } else {
                        this.fatosGeradores = [];
                        this.resetFatoGerador();
                    }
                    this.isLoadingProduto= false;

                    const maxEmpregadosSubstituidos = justificativa.funcionariosSubstituidosMax;
                    const minEmpregadosSubstituidos = justificativa.funcionariosSubstituidosMin;
                    if (!this.solicitacao.matriculaEmpregadosSubstituidos || this.quantidadeEmpregadosSubstituidosMostrados === 0) {
                        this.solicitacao.matriculaEmpregadosSubstituidos = [""];
                    }
                    if (maxEmpregadosSubstituidos >= minEmpregadosSubstituidos) {
                        while (justificativa.funcionariosSubstituidosMin && this.quantidadeEmpregadosSubstituidosMostrados < justificativa.funcionariosSubstituidosMin) {
                            this.adicionarEmpregadoSubstituido(this.quantidadeEmpregadosSubstituidosMostrados - 1, maxEmpregadosSubstituidos)

                        }

                        while (justificativa.funcionariosSubstituidosMax && this.quantidadeEmpregadosSubstituidosMostrados > justificativa.funcionariosSubstituidosMax) {
                            this.removerEmpregadoSubstituido(this.quantidadeEmpregadosSubstituidosMostrados - 1, minEmpregadosSubstituidos);
                        }
                    }
                } else {
                    this.produtos = [];
                    this.fatosGeradores = [];
                    this.resetProduto();
                    this.resetFatoGerador();
                }
            }
        );

        reaction(
            () => this.produtos,
            produtos => {
                if(produtos && produtos.length > 0 && this.idProdutoSelecionado){
                    this.solicitacao.produtoId = this.idProdutoSelecionado.id;
                }
            }
        );
    }


    @computed
    get exibeDetalhamentoHistorico() {
        return this.isSolicitacaoDeAjuste;
    }

    @computed
    get exibeGestorSolicitanteAdminExcecao() {
        return this.loginStore.usuarioLogado.perfilAdministrador && this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get isClonagemExcecaoSemPermissao() {
        return this.isSolicitacaoDeClonagem && this.solicitacao.solicitacaoExcecao && !this.loginStore.isSolicitanteMOTExcecao;
    }

    @computed
    get exibeJustificativaExcecao() {
        return this.loginStore.isSolicitanteMOTExcecao || this.isSolicitacaoDeAjuste;
    }

    @computed
    get exibeCheckboxSolicitacaoExcecao() {
        return this.loginStore.isSolicitanteMOTExcecao;
    }

    carregarFiltroEmpregadosSubstituidos(empregados, motivo) {
        if(empregados.length > 0 && motivo === "SUB") {
            for(let empregado of empregados) {
                this.empregadoService.getByMatricula(empregado.matricula).then(response => {
                if(response.data){
                    response.data.map(empregado => {
                        this.empregadosFiltrados.push(empregado);
                    });
                }
                }).catch(error => {
                    console.log(error)
                });
            }
        }
    }

    @computed
    get exibeSalarioBase() {
        return !this.loginStore.isAnalistaLogado;
    }

    @computed
    get salarioBaseCargo(){
        return this.solicitacao.cargo.salarioBase ? this.solicitacao.cargo.salarioBase : "";
    }

    @computed
    get exibeValorAcheCargo() {
        return this.solicitacao.cargo && this.solicitacao.cargo.salarioBase && this.solicitacao.cargo.percentualAche && !this.loginStore.isAnalistaLogado;
    }

    @computed
    get gestorCentroCustoDebitoEditavel() {
        return this.solicitacao.centroCustoDebito && this.solicitacao.localContratacaoId;
    }

    @computed
    get ettExcecaoEditavel() {
        return this.etts && this.etts.length > 0;
    }

    @computed
    get exibeSalarioExcecao() {
        return this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get exibePercentualSalarioGlobo() {
        return !this.loginStore.isAnalistaLogado && this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo && this.solicitacao.cargo.salarioBase && this.solicitacao.solicitacaoExcecao;
    }

    @computed
    get exibeGdv() {
        return !this.loginStore.isAnalistaLogado && this.solicitacao.cargo && !!this.solicitacao.cargo.percentualGDV;
    }

    @computed
    get exibeInsalubridade() {
        return !this.loginStore.isAnalistaLogado;
    }

    @computed
    get exibePericulosidade() {
        return !this.loginStore.isAnalistaLogado;
    }

    @computed
    get quantidadeDias() {
        return (this.solicitacao.momentDataTermino && this.solicitacao.momentDataInicio) ? this.solicitacao.momentDataTermino.diff(this.solicitacao.momentDataInicio, 'days') + 1 : "";
    }

    @computed
    get isGestorAreaDebitoSelecionado() {
        return this.solicitacao.gestorAreaDebito && this.solicitacao.gestorAreaDebito.matricula;
    }

    @computed
    get quantidadeEmpregadosSubstituidosMostrados() {
        const qnt = [];
        this.solicitacao.matriculaEmpregadosSubstituidos.map(empregado => {
            if (empregado !== null) {
                qnt.push(empregado)
            }
        });
        return qnt.length;
    }

    @computed
    get posicaoPrimeiroEmpregadoSubstituido() {
        this.solicitacao.matriculaEmpregadosSubstituidos.map((empregado, index) => {
            if (empregado !== null) {
                return index;
            }
        });
    }

    @computed
    get salarioExcecaoMin() {
        return this.parametros && this.parametros.smrsgPrctRgl && this.solicitacao.cargo && this.solicitacao.cargo.salarioGlobo ? this.solicitacao.cargo.salarioGlobo * (this.parametros.smrsgPrctRgl / 100) : null
    }

    @computed
    get mensagemErroSalarioExcecao() {
        const percentualMin = this.parametros && this.parametros.smrsgPrctRgl;
        return `Valor informado deve ser maior que ${percentualMin}%`
    }

    @computed
    get posicaoPrimeiroAprovadorExtra() {
        this.solicitacao.matriculaAprovadoresExtra.map((empregado, index) => {
            if (empregado !== null) {
                return index;
            }
        });
    }

    @computed
    get quantidadeAprovadoresExtraMostrados() {
        const qnt = [];
        this.solicitacao.matriculaAprovadoresExtra.map(empregado => {
            if (empregado !== null) {
                qnt.push(empregado)
            }
        });
        return qnt.length;
    }

    @computed
    get exibirDescricaoSolicitacaoCentroCustoDebito() {
        if (this.solicitacao.centroCustoDebito && _.get(this.solicitacao.gestorAreaDebito, "nomeArea")) {
            return this.solicitacao.centroCustoDebito + ' ' + this.solicitacao.gestorAreaDebito.nomeArea;
        } else if (this.solicitacao.centroCustoDebito) {
            return this.solicitacao.centroCustoDebito
        } else {
            return "";
        }
    }

    @computed
    get exibirGestorSolicitante() {
        if (_.get(this.solicitacao, "gestorSolicitante.nome")) {
            const matricula = _.get(this.solicitacao, "gestorSolicitante.matricula") && " (" + this.solicitacao.gestorSolicitante.matricula + ")";
            return this.solicitacao.gestorSolicitante.nome + matricula;
        } else {
            return "";
        }
    }

    @computed
    get apenasMatriculaAprovadoresExtraValidos() {
        const matriculasValidas = [];
        if (this.solicitacao.optionAprovadoresExtra) {
            this.solicitacao.optionAprovadoresExtra.map(option => {
                if (option) {
                    matriculasValidas.push(parseInt(option.value));
                }
            });
        }
        return matriculasValidas;
    }

    @computed
    get empregadosFiltradosSelecionados() {
        return this.empregadosFiltrados.filter( elem => {
            for(let e of this.solicitacao.matriculaEmpregadosSubstituidos) {
                if(typeof e === "object" ) {
                    if(e.value == elem.matricula+"") return true;
                } else if(e.length === 11){
                    if(e == elem.cpf) return true;
                } else {
                    if(e == elem.matricula+"") return true;
                }
            }
            return false;
        } )
    }

    @computed
    get apenasMatriculaEmpregadosSubstituidosValidos() {
        const matriculasValidas = [];

        this.solicitacao.matriculaEmpregadosSubstituidos.map(empregado => {
            if (empregado && typeof empregado === "object") {
                matriculasValidas.push(String(empregado.value));
            } else if (empregado && empregado.length === 11) {
                matriculasValidas.push(String(getByAtribute(this.empregadosFiltrados, empregado, "cpf").matricula));
            } else if (empregado) {
                matriculasValidas.push(String(empregado));
            }
        });
        return matriculasValidas;
    }

    @computed
    get apenasCpfIndicacoes() {
        let indicacoes = this.solicitacao.indicacoes;
        if(this.solicitacao.indicacoes && this.solicitacao.indicacoes.length > 0) {
            indicacoes = indicacoes.filter(i => i.cpf).map(i => i.cpf);
        }

        return indicacoes;
    }

    @computed
    get isFluxoNovo(){
        return (this.detalhesTarefa && this.detalhesTarefa.idFluxo && this.detalhesTarefa.idFluxo > 0);
    }
    
    atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo() {
        const cargoId = this.solicitacao.cargoId;
        const empresaGloboId = this.solicitacao.localContratacaoId;
        const cargo = getByAtribute(this.cargos, this.solicitacao.cargoId, "id");
        this.solicitacao.cargo = {};
        this.resetarDadosSoc();
        if (cargoId && empresaGloboId && cargo) {
            this.carregandoCargo = true;
            this.cargoService.getDetalhesByEmpresaGlobo(cargoId, cargo.nome, empresaGloboId).then(response => {
                this.carregandoCargo = false;
                if(response.data) {
                    extendObservable(this.solicitacao.cargo, response.data);
                    this.solicitacao.cargo = response.data;
                    _.set(this.solicitacao.cargo, "id", this.solicitacao.cargoId);
                    this.carregarEttsPorCompetenciaCargo();
                    const lotacoesCopy = JSON.parse(JSON.stringify(this.lotacoes));
                    this.cargoSelecionado = {value: cargo.id, label: cargo.nome + " ("+cargo.id+")"}
                    this.consultarDadosSoc(
                        lotacoesCopy.filter(x => x.id == this.solicitacao.lotacaoId).pop().cnpj,
                        this.solicitacao.centroCustoDebito,
                        cargoId
                    );

                }
            }).catch(error => {
                this.formErrorsStore.addError(error);
                this.carregandoCargo = false;
            });
        }
        else {
            this.solicitacao.cargo = {};
        }
    }

    getUsuarioLogado() {
        const usuarioLogado = this.loginStore.usuarioLogado;
        if (usuarioLogado) {
            this.solicitacao.usuarioSolicitanteId = usuarioLogado.id;
            this.solicitacao.usuarioSolicitante = usuarioLogado;
            if (_.get(this.loginStore, "usuarioLogado.gestores.length") === 1) {
                this.solicitacao.gestorSolicitante = this.loginStore.usuarioLogado.gestores[0];
                this.solicitacao.gestorSolicitanteId = this.solicitacao.gestorSolicitante.id;
                this.carregarDadosGestorSolicitante();
            }
        }
    }

    carregarDadosGestorSolicitante(ignorarDadosExtras = false) {
        const matricula = this.solicitacao.gestorSolicitante.matricula;
        this.alertaGestorSolicitante = "";
        this.empregadoService.getByMatricula(matricula).then(response => {
            if (response.status === 204 || !response.data || response.data.length === 0 ) {
                this.alertaGestorSolicitante = "Gestor solicitante não encontrado no Conecta HCM. Favor informar ao administrador do sistema.";
                return;
            }
            // Assumindo que getByMatricula retorna um array com no máximo um empregado
            const empregado = response.data[0];

            if (!empregado.ativo) {
                this.alertaGestorSolicitante = "Gestor solicitante não está ativo no Conecta HCM. Favor informar ao administrador do sistema.";
                return;
            }

            this.solicitacao.gestorSolicitante.nomeArea = empregado.nomeArea;
            this.solicitacao.gestorSolicitante.nomeCentral = empregado.nomeCentral;
            this.solicitacao.gestorSolicitante.nomeDepartamento = empregado.nomeDepartamento;
            this.solicitacao.gestorSolicitante.nomeDivisao = empregado.nomeDivisao;
            this.solicitacao.gestorSolicitante.centroCusto = empregado.centroCusto;
            this.solicitacao.gestorSolicitante.posicao = empregado.posicao;
            this.solicitacao.gestorSolicitante.telefone = empregado.telefone;
            this.solicitacao.gestorSolicitante.email = empregado.email;
            this.solicitacao.gestorSolicitante.labelValue = empregado.nome + " (" + empregado.matricula + ")";

            if (!empregado.email) {
                this.alertaGestorSolicitante = "E-mail corporativo do gestor solicitante não foi identificado no Conecta HCM. Favor informar ao administrador do sistema.";
                return;
            }

            if (!ignorarDadosExtras) {
                this.setContatoGloboByGestor();
                this.setCCDebitoByGestor();
            }
        }).catch(error => {
            this.formErrorsStore.addError(error);
            console.log(error)
        })
    }

    carregarEttsPorCompetenciaCargo = () => {
        const idCompetenciaCargo = _.get(this.solicitacao, "cargo.competenciaCargo.id");
        const empresaGloboId = _.get(this.solicitacao, "localContratacaoId");
        if (!!idCompetenciaCargo) {
            this.loadingEtts = true;
            this.ettService.listByNomeCompetenciaCargo(idCompetenciaCargo, empresaGloboId).then(response => {
                this.etts = response.data;
                this.validarEttsSelecionadas();
                this.loadingEtts = false;
            }).catch(error => {
                this.formErrorsStore.addError(error);
                console.log(error);
                this.loadingEtts = false;
            });
        } else {
            this.etts = [];
            this.validarEttsSelecionadas();
        }

    };

    validarEttsSelecionadas = () => {
        for (let indicacao of this.solicitacao.indicacoes) {
            const indicacaoExiste = !!getByAtribute(this.solicitacao.indicacoes, indicacao.ettId, "id");
            if (!indicacaoExiste) {
                indicacao.ettId = null;
            }
        }
    };

    resetJustificativa() {
        if (!getByAtribute(this.justificativasContratacao, this.solicitacao.justificativaContratacaoId, "id")) {
            this.solicitacao.justificativaContratacaoId = "";
            this.solicitacao.justificativaContratacao = {
                "id": "",
                "nome": "",
                "motivoContratacao": "",
                "classificacaoRisco": "",
                "justificativaAlocavel": "",
                "ativo": true,
                "descricao": ""
            };
        }
    }

    resetProduto() {

        const reset = () => {
            this.solicitacao.produtoId = "";
            this.solicitacao.produto = {
                id: null,
                nome: "",
                codigo: "",
                justificativaContratacaoId: "",
                justificativaContratacao: {
                    id: 0,
                    nome: ""
                },
                descricaoMot: "",
                sistemaAlocacao: "MOT",
                ativo: false
            };
        };

        if (!getByAtribute(this.produtos, this.solicitacao.produtoId, "id" ||
            !getByAtribute(this.produtos, this.solicitacao.produto.codigo, "codigo"))) reset();
    }

    resetFatoGerador() {
        if (!getByAtribute(this.fatosGeradores, this.solicitacao.fatoGeradorId, "id")) {
            this.solicitacao.fatoGeradorId = "";
            this.solicitacao.fatoGerador = {
                "id": 0,
                "nome": "",
                "descricaoMot": "",
                "sistemaAlocacao": "",
                "justificativaContratacaoId": 0
            };
        }
    }

    setTitulo(path) {
        if (path === "/nova-solicitacao-contratacao/:id") {
            this.tituloPaginaStore.setTitulo("Nova solicitação de contratação");
        } else if (path === "/clonar-solicitacao-contratacao/:id") {
            this.tituloPaginaStore.setTitulo("Clonagem solicitação de contratação");
        } else if (path === "/ajuste-solicitacao/:id") {
            this.tituloPaginaStore.setTitulo("Ajuste solicitação de contratação");
        }
    }

    carregarParametrosGerais() {
        this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", true);
        this.parametroGeralService.list().then(response => {
            this.parametros = response.data;
            this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", false);
        }).catch(error => {
            this.formErrorsStore.addError(error);
            this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", false);
            console.log(error)
        });
    }

    carregarLista(id, path) {
        this.path = path;
        if (this.path === "/nova-solicitacao-contratacao") {
            this.getUsuarioLogado();
        }
        this.carregarParametrosGerais();
        this.carregarlocalTrabalho();
        this.carregarEmpresasGlobo();
        this.carregarLotacoes();

        if (id && path === "/nova-solicitacao-contratacao/:id") {
            this.solicitacaoService.carregarRascunho(id).then(response => {
                this.prepararSolicitacao(response.data);
                if (!this.loginStore.isSolicitanteMOTExcecao) {
                    response.data.solicitacaoExcecao = false;
                }
                extendObservable(this.solicitacao, response.data);
                this.definicaoTarefaId = response.data.definicaoTarefaId;
                this.solicitacao = response.data;
                this.validarCpfIndicacoes(false);
                if (!this.verificarobterCargoSubstituido()) {
                    this.obterCargoSubstituido = false;
                    //this.solicitacao.cargo = null;
                    //this.solicitacao.cargoId = null;
                }
                this.idProdutoSelecionado = this.solicitacao.produto;
            }).then(() => this.carregarInfoGestorSolicitante())
                .then(() => this.carregarDadosGestorSolicitante(true))
                .then(() => this.carregarGestoresCentroCustoDebito())
                .then(() => this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo())
                .catch(error => {
                    this.formErrorsStore.addError(error);
                    console.log(error);
                });
        } else if (id && path === "/clonar-solicitacao-contratacao/:id") {
            this.isSolicitacaoDeClonagem = true;
            this.solicitacaoService.carregarSolicitacao(id).then(response => {
                this.prepararSolicitacao(response.data);
                extendObservable(this.solicitacao, response.data);
                this.solicitacao = response.data;
                this.getUsuarioLogado();
                this.solicitacao.status = "RAS";
                this.definicaoTarefaId = response.data.definicaoTarefaId;
                this.setTipoEmailContratacao(this.solicitacao.tipoEmailContratacao ? this.solicitacao.tipoEmailContratacao.toString() : null);
                this.validarCpfIndicacoes(false);
            }).then(() => this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo())
                .catch(error => {
                    this.formErrorsStore.addError(error);
                    console.log(error);
                });
        } else if (id && ((path === "/ajuste-solicitacao/:id") || (path === "/ajuste-solicitacao-contrato/:id"))) {
            this.isSolicitacaoDeAjuste = true;
            this.taskAjustId = id;

            const getPromise = path === "/ajuste-solicitacao-contrato/:id"
                ? this.fluxoService.getSolicitacaoContratacao(id)
                : this.solicitacaoService.get(id);
            
            getPromise.then(response => {
                this.prepararSolicitacao(response.data.solicitacao);
                this.aprovadoresExtra = response.data.aprovadoresExtra;
                this.detalhesTarefa = response.data;
                extendObservable(this.solicitacao, response.data.solicitacao);
                this.solicitacao = response.data.solicitacao;
                this.definicaoFluxoId = response.data.definicaoFluxoId;
                this.definicaoTarefaId = response.data.definicaoTarefaId;
                this.idSolicitacao = response.data.solicitacaoEtt ? response.data.solicitacaoEtt.idSolicitacaoEtt : response.data.solicitacao.id;
                this.setTipoEmailContratacao(this.solicitacao.tipoEmailContratacao ? this.solicitacao.tipoEmailContratacao.toString() : null);
                this.getComentarios();
                this.getTarefasFluxo();
                this.validarCpfIndicacoes(false);
                if (!this.verificarobterCargoSubstituido()) {
                    this.obterCargoSubstituido = false;
                    //this.solicitacao.cargo = null;
                    //this.solicitacao.cargoId = null;
                }
            }).then(() => this.carregarGestoresCentroCustoDebito())
                .then(() => this.carregarDadosGestorSolicitante(true))
                .then(() => this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo())
                .catch(error => {
                    this.formErrorsStore.addError(error);
                    console.log(error)
                })
        }
        this.motivosContratacao = motivoContratacaoEnum;
    }

    getIdAprovadorGestorArDebito() {
        if (this.solicitacao.gestorAreaDebito && this.solicitacao.gestorAreaDebito.matricula) {
            const gestor = this.solicitacao.gestorAreaDebito;
            const matricula = this.solicitacao.gestorAreaDebito.matricula;
            this.loadingGestorArDebito = true;
            this.solicitacao.gestorAreaDebito = null;
            this.gestorARError = [];
            this.empregadoService.getEbsByMatricula(matricula).then(response => {
                if (response.data && getByAtribute(this.gestoresArDebito, response.data.idAprovador, "idAprovador")) {
                    gestor.idAprovador = response.data.idAprovador;
                    gestor.nome = response.data.nome;
                    this.solicitacao.gestorAreaDebito = gestor;
                    this.solicitacao.gestorAreaDebitoId = gestor.id;
                }
                this.loadingGestorArDebito = false;
            }).catch(error => {
                this.formErrorsStore.addError(error);
                this.gestorARError = _.get(error, "response.data.message") ? [_.get(error, "response.data.message")] : [];
                this.loadingGestorArDebito = false;
            })
        }
    }

    prepararIndicacoes = (indicacoes) => {
        return indicacoes.map(i => {
            i.mensagemErroBloqueante = null;
            i.mensagemErroAviso = null;
            i.key = shortid.generate();
            return i;
        })
    };

    prepararSolicitacao(solicitacao) {

        if(!solicitacao.produto){
            solicitacao.produto = {};
        }
        if(solicitacao.cargo){
            this.cargos.push(solicitacao.cargo);
            this.solicitacao.cargoId = solicitacao.cargo.id;
            this.solicitacao.cargo = solicitacao.cargo
        }
        if (solicitacao.justificativaContratacao) {
            solicitacao.motivoContratacao = solicitacao.justificativaContratacao.motivoContratacao;
        } else {
            solicitacao.motivoContratacao = "";
        }
        solicitacao.contatoGlobo = solicitacao.contatoGloboId ? solicitacao.contatoGlobo : {
            id: 0,
            "nome": "",
            "telefone": "",
            "email": ""
        };
        solicitacao.indicacoes = solicitacao.indicacoes.length > 0 ? this.prepararIndicacoes(solicitacao.indicacoes) : [{
            id: 0,
            cpf: "",
            nome: "",
            ettId: "",
            email: "",
            telefone: "",
            mensagemErroBloqueante: null,
            mensagemErroAviso: null,
            key: shortid.generate()
        }];
        if (solicitacao.empregadosSubstituidos && solicitacao.empregadosSubstituidos.length > 0) {
            this.carregarFiltroEmpregadosSubstituidos(solicitacao.empregadosSubstituidos, solicitacao.motivoContratacao);
            solicitacao.matriculaEmpregadosSubstituidos = solicitacao.empregadosSubstituidos.map(empregado => {
                return empregado.matricula.toString();
            })
        } else {
            solicitacao.matriculaEmpregadosSubstituidos = [""];
        }
        if (_.get(solicitacao.gestorSolicitante, "nome")) {
            solicitacao.gestorSolicitante.labelValue = solicitacao.gestorSolicitante.nome + " (" + solicitacao.gestorSolicitante.matricula + ")";
        } else {
            solicitacao.gestorSolicitante = null;
        }
        if (!solicitacao.matriculaAprovadoresExtra) {
            solicitacao.matriculaAprovadoresExtra = [""];
        }
        if (this.isClonagemExcecaoSemPermissao) {
            this.solicitacao.solicitacaoExcecao = false;
        }
        if (this.isSolicitacaoDeClonagem) {
            delete solicitacao.id;
            solicitacao.usuarioSolicitanteId = 0;
            solicitacao.usuarioSolicitante = {
                "id": 0,
                "nome": "",
                "login": "",
            };
            solicitacao.gestorSolicitanteId = 0;
            solicitacao.gestorSolicitante = {
                "id": 0,
                "matricula": 0,
                "cpf": "",
                "nome": "",
                "centroCusto": "",
                "nomeArea": "",
                "nomeCentral": "",
                "nomeDivisao": "",
                "nomeDepartamento": "",
                "telefone": "",
                "email": ""
            };
            solicitacao.matriculaEmpregadosSubstituidos = [""];
            solicitacao.empregadosSubstituidos = [];
            solicitacao.dataInicio = null;
            solicitacao.dataTermino = null;
            solicitacao.gestorAreaDebitoId = null;
            solicitacao.gestorAreaDebito = null;
            solicitacao.contatoGlobo = {
                nome: "",
                telefone: "",
                email: ""
            };
            solicitacao.centroCustoDebito = "";
        }

        if (solicitacao.dataInicio) {
            solicitacao.momentDataInicio = moment(solicitacao.dataInicio);
            this.setMomentDataInicio(solicitacao.momentDataInicio);
        } else {
            solicitacao.momentDataInicio = null;
        }
        if (solicitacao.dataTermino) {
            solicitacao.momentDataTermino = moment(solicitacao.dataTermino);
            this.setMomentDataTermino(solicitacao.momentDataTermino);
        } else {
            solicitacao.momentDataTermino = null;
        }

        solicitacao.localTrabalhoCodigo = _.get(solicitacao, "localTrabalho.codigo");
        solicitacao.localTrabalho.template = _.get(solicitacao, "localTrabalho.uf") + " - " + _.get(solicitacao, "localTrabalho.template");
        solicitacao.tipoEmailContratacao = _.get(solicitacao, "tipoEmailContratacao") || null;
    }

    getComentarios() {
        if (this.idSolicitacao) {
            this.fluxoService.getHistoricoFLuxo("GloboMOTSolicitacaoMOT", this.idSolicitacao).then(response => {
                this.comentarios = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    }
    
    getTarefasFluxo(){
        if (this.isFluxoNovo){
            this.fluxoService.getEvolucaoFluxo(this.detalhesTarefa.idFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data && Array.isArray(response.data)) {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    carregarMotivoContratacao() {
        if (this.solicitacao.justificativaContratacao) {
            this.justificativaContratacaoService.listByMotivo(this.solicitacao.justificativaContratacao.motivoContratacao)
                .then(response => {
                    this.justificativasContratacao = response.data;
                }).catch(erro => {
                this.formErrorsStore.addError(error);
                console.log(erro);
            })
        }
    }

    carregarInfoGestorSolicitante() {
        if (!this.solicitacao.gestorSolicitante) {
            this.getUsuarioLogado();
        }
    }

    carregarEmpresasGlobo() {
        this.loadingPanelStore.setIsLoading("empresasLoading", true);
        this.empresaGloboService.list().then(response => {
            this.empresasGlobo = response.data;
            this.loadingPanelStore.setIsLoading("empresasLoading", false);
        }).catch(error => {
            this.formErrorsStore.addError(error);
            this.loadingPanelStore.setIsLoading("empresasLoading", false);
            console.log(error);
        });
    }

    carregarLotacoes(){
        this.lotacaoService.listBUAtivas().then(response =>{
            this.lotacoes = response.data.filter(x => (x.ativo === true && x.empresaGlobo !== null))
        }).catch(error=>{
            this.formErrorsStore.addError(error);
        })
    }

    carregarlocalTrabalho() {
        this.loadingPanelStore.setIsLoading("localTrabalhoLoading", true);
        this.localTrabalhoService.list().then(response => {
            this.locaisTrabalho = response.data;
            this.loadingPanelStore.setIsLoading("localTrabalhoLoading", false);
        }).catch(error => {
            this.formErrorsStore.addError(error);
            this.loadingPanelStore.setIsLoading("localTrabalhoLoading", false);
        });
    }

    _filtrarCargos(input, callback){
        if (input && input.length > 2){
            this.cargoService.listCargosHcmByPrefixoNome(input).then(response =>{
                this.cargos = response.data;
                callback(null, {
                    options: response.data.map(cargo => {
                        return {"value":cargo.id, "label": cargo.nome +" ("+cargo.id+")"};
                    }),
                    complete: false
                });
            }).catch(error =>{
                console.log(error)
                callback(null, {options: [], complete: false});
            })
        }
        else{
            callback(null, {options: [], complete: false});
        }
    }

    filtrarCargoPorNome(nome){
        if (nome){
            this.cargoService.listByPrefixoNome(nome).then(response =>{
                this.cargos = response.data;
            }).catch(error =>{
                console.log(error)
            })
        }
    }

    _filtrarAprovadoresExtra(input, callback) {
        if (input && input.length > 2){
            this.empregadoService.filtrarGestoresPorNh(input).then(response =>{
                callback(null, {
                    options: response.data.map(aprovador => {
                        return {"value":aprovador.value, "label": aprovador.label};
                    }),
                    complete: false
                });

            }).catch(error =>{
                callback(null, {
                    options: [],
                    complete: false
                });
                console.log(error);
            })
        }else {
            callback(null, {options: [], complete: false});
        }
    }

    carregarAprovadoresExtra(prefixoNome) {
        this.loadingPanelStore.setIsLoading("aprovadoresLoading", true);
        this.empregadoService.filtrarGestoresPorNh(prefixoNome).then(response => {
            this.todosAprovadores = response.data;
            this.loadingPanelStore.setIsLoading("aprovadoresLoading", false);
        }).catch(error => {
            this.formErrorsStore.addError(error);
            this.loadingPanelStore.setIsLoading("aprovadoresLoading", false);
            console.log(error);
        });
    }

    _filtrarEmpregados(input, callback) {
        this.empregadoService.getByCPFOrMatricula(input, callback).then(response => {
            if (response && response.length > 0) {
                this.empregadosFiltrados.push(...response);
            }
            callback(null, {
                options: response.map(empregado => {
                    const cpf = !!empregado.cpf ? " (" + empregado.cpf + ")" : "";
                    return {value: empregado.matricula.toString(), label: empregado.matricula + " - " + empregado.nome + cpf};
                }),
                complete: false
            });
        }).catch(error => {
            this.formErrorsStore.addError(error);
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    _filtrarGestoresSolicitantes(input, callback) {
        this.empregadoService.listarGestores(input, callback).then(response => {
            callback(null, {
                options: response.map(empregado => {
                    empregado.labelValue = empregado.nome + " (" + empregado.matricula + ")";
                    return empregado;
                }),
                complete: false
            });
        }).catch(error => {
            this.formErrorsStore.addError(error);
            callback(null, {
                options: [],
                complete: false
            });
        });
    }

    filtrarAreaDebito(input, callback) {
        const result = [];
        if (input && input.length === 11) {
            // transformar o valor digitado em caixa alta para resolver erro em lotes de pagto 
            input = input.toUpperCase();
            this.gestoresArDebito = null;
            result.push({value: input, label: input});
            callback(null, {options: result, complete: false});
        } else {
            callback(null, { options: result, complete: false });
        }
    }

    adicionarIndicacao(index) {
        this.solicitacao.indicacoes.splice(index + 1, 0, {
            id: 0,
            cpf: "",
            nome: "",
            ettId: "",
            email: "",
            telefone: "",
            mensagemErroBloqueante: null,
            mensagemErroAviso: null,
            key: shortid.generate()
        });
    }

    checkIndicacaoCpf(index) {
        const cpf = this.solicitacao.matriculaEmpregadosSubstituidos[index];
    }

    removerIndicacao(index) {
        this.solicitacao.indicacoes.splice(index, 1);
    }

    adicionarEmpregadoSubstituido(index, max) {
        var quantidadeCPFs = this.quantidadeEmpregadosSubstituidosMostrados;
        if (max === null || quantidadeCPFs < max)
            this.solicitacao.matriculaEmpregadosSubstituidos.splice(index + 1, 0, "");
    }

    adicionarAprovadorExtra(index) {
        this.solicitacao.matriculaAprovadoresExtra.splice(index + 1, 0, "");
        this.solicitacao.optionAprovadoresExtra.splice(index + 1, 0, {});
    }

    removerEmpregadoSubstituido(index, min) {
        var quantidadeCPFs = this.quantidadeEmpregadosSubstituidosMostrados;
        if (min === null || quantidadeCPFs > min) {
            this.solicitacao.matriculaEmpregadosSubstituidos.splice(index, 1);
        }
        if (!this.verificarobterCargoSubstituido()) {
            this.obterCargoSubstituido = false;
            this.solicitacao.cargo = null;
            this.solicitacao.cargoId = null;
        }
    }

    removerAprovadorExtra(index) {
        this.solicitacao.matriculaAprovadoresExtra.splice(index, 1);
        this.solicitacao.optionAprovadoresExtra.splice(index, 1);
    }

    toggleIsExcecao() {
        this.solicitacao.solicitacaoExcecao = !this.solicitacao.solicitacaoExcecao;
        this.validarCpfIndicacoes();
        if (_.get(this.loginStore, "usuarioLogado.gestores.length") === 1 && !this.solicitacao.solicitacaoExcecao) {
            this.solicitacao.gestorSolicitante = this.loginStore.usuarioLogado.gestores[0];
            this.solicitacao.gestorSolicitanteId = this.solicitacao.gestorSolicitante.id;
            this.carregarDadosGestorSolicitante();
        } else {
            this.solicitacao.gestorSolicitante = null;
            this.solicitacao.gestorSolicitanteId = null;
        }
    }

    toggleEnviarModal() {
        this.enviarModalIsOpen = !this.enviarModalIsOpen;
    }

    setLocalContratacao(value) {
        this.solicitacao.localContratacaoId = value;
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo();
        this.setCCDebitoByGestor();

        if (!this.verificarobterCargoSubstituido()) {
            this.obterCargoSubstituido = false;
        }


        if (!value) {
            this.solicitacao.cargo = null;
            this.solicitacao.cargoId = null;
        }

        this.validarCpfIndicacoes();
    }

    setLotacao(value){
        this.solicitacao.lotacaoId = value
        if( value && value !== "") {
            const lotacao = this.lotacoes.filter(x => x.id === value).pop()
            if (lotacao.empresaGlobo != null) {
                this.setLocalContratacao(lotacao.empresaGlobo.id)
            }
            this.consultarDadosSoc(lotacao.cnpj, this.solicitacao.centroCustoDebito, this.solicitacao.cargo.cargoId)
        }


    }

    consultarDadosSoc(cnpjUnidade, codigo, codigoRhCargo){
        if (codigoRhCargo) {
            const parametros = {
                cnpjUnidade: cnpjUnidade,
                codigoRhSetor: codigo,
                codigoRhCargo: codigoRhCargo
            };

            this.dadosSocService.consultar(parametros).then(response => {
                this.dadosSoc = response.data;
                this.solicitacao.descricaoEpis = this.dadosSoc.epi;
                this.solicitacao.cargo.possuiInsalubridade = this.dadosSoc.insalubridade;
                this.solicitacao.cargo.possuiPericulosidade = this.dadosSoc.periculosidade;

            }).catch(error => {
                console.log(error);
            })
        }

    }

    resetarDadosSoc(){
        this.dadosSoc = {}
        this.solicitacao.descricaoEpis = "";
        this.solicitacao.cargo.possuiInsalubridade = null;
        this.solicitacao.cargo.possuiPericulosidade = null;
    }

    setLocalTrabalho(value, options) {
        this.solicitacao.localTrabalhoCodigo = value;
        this.solicitacao.localTrabalho = _.get(options, "[0]");
        this.solicitacao.localTrabalhoId = _.get(this.solicitacao.localTrabalho, "id");
        //TODO: verificar se tem que remover o item anterior
        if (!value) {
            this.solicitacao.localTrabalhoId = ""
        }
    }

    setJustificativaContratacao(value) {
        this.solicitacao.justificativaContratacaoId = value;
        if(value) {
            this.solicitacao.justificativaContratacao = getByAtribute(this.justificativasContratacao, value, "id");
        }
        this.solicitacao.produtoId = "";

        this.resetJustificativa();
        this.resetProduto();
    }

    setDetalhamentoJustificativa(value) {
        this.solicitacao.detalhamentoJustificativa = value;
    }

    setQuantidadeRecursos(value) {
        if (value < 0)
            this.solicitacao.quantidadeRecursos = Math.floor(value) * -1;
        else if (value == 0)
            this.solicitacao.quantidadeRecursos = 1;
        else
            this.solicitacao.quantidadeRecursos = Math.floor(value);
    }

    setSalarioExcecao(value) {
        this.solicitacao.salarioExcecao = value;
    }

    setObservacoes(value) {
        this.observacoes = value
    }

    setDataInicioCheck(value) {
        this.dataInicioValidacao = value;
    }

    setMomentDataInicio(value) {
        if (value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            this.solicitacao.momentDataInicio = startDate;
            if (startDate != null && startDate.length !== 0) {
                this.solicitacao.dataInicio = startDate.toJSON();
            } else {
                this.solicitacao.dataInicio = null;
            }
            this.dataInicioValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.solicitacao.dataInicio = null;
            this.solicitacao.momentDataInicio = null;
            this.dataInicioValidacao = null;
        }
        this.validarCpfIndicacoes();
    }

    setDataTerminoCheck(value) {
        this.dataTerminoValidacao = value;
    }

    carregarGestoresCentroCustoDebito = () => {
        //TODO: refatorar
        /**
         * Array gestoresArDebito não será mais esvaziado para evitar efeitos "pisca-pisca" nos elementos que dependam
         * de seu estado.
         *
         * this.gestoresArDebito = [];
         */
        if (this.solicitacao.centroCustoDebito && this.solicitacao.localContratacaoId) {
            this.targetCentroCustoDebito = "MOT";
            this.isLoadingArDebito = true;
            if(this.gestoresArDebito == null){
                this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(this.solicitacao.centroCustoDebito, this.solicitacao.localContratacaoId).then(function(response)  {
                    if (!!response.data) {
                        this.gestoresArDebito = response.data.gestores;
                        if (_.get(this.solicitacao, "gestorAreaDebito.idAprovador")) {
                            if (!getByAtribute(this.gestoresArDebito, this.solicitacao.gestorAreaDebito.idAprovador, "idAprovador")) {
                                this.solicitacao.gestorAreaDebito = null;
                            }
                        }
                        this.targetCentroCustoDebito = response.data.target;
                    } else {
                        this.gestoresArDebito = [];
                        this.solicitacao.gestorAreaDebito = null;
                    }
                    this.isLoadingArDebito = false;
                }.bind(this)).catch(error => {
                    this.formErrorsStore.addError(error);
                    console.log(error)
                    this.isLoadingArDebito = false;
                    this.gestoresArDebito = [];
                    this.solicitacao.gestorAreaDebito = null;
                    this.solicitacao.centroCustoDebito = null;
                })
            }
        } else {
            this.gestoresArDebito = [];
            this.solicitacao.gestorAreaDebito = null;
            this.solicitacao.centroCustoDebito = null;
        }
    };

    setMomentDataTermino(value) {
        if (value) {
            let endDate = value;
            endDate = moment(endDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            this.solicitacao.momentDataTermino = endDate;
            if (endDate != null && endDate.length !== 0) {
                this.solicitacao.dataTermino = endDate.toJSON();
            } else {
                this.solicitacao.dataTermino = null;
            }
            this.dataTerminoValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.solicitacao.dataTermino = null;
            this.solicitacao.momentDataTermino = null;
            this.dataTerminoValidacao = null;
        }
    }

    setGestorSolicitante(value, options) {
        if (options && options.length > 0) {
            this.solicitacao.gestorSolicitante = options[0];
            this.solicitacao.gestorSolicitanteId = this.solicitacao.gestorSolicitante.id;
            this.carregarDadosGestorSolicitante();
        } else {
            this.solicitacao.gestorSolicitante = null;
            this.solicitacao.gestorSolicitanteId = null;
            this.alertaGestorSolicitante = "";
        }
    }

    setContatoGloboByGestor() {
        if (this.solicitacao.gestorSolicitante && this.solicitacao.gestorSolicitante.email) {
            this.solicitacaoService.obterContatoAtualPorEmail(this.solicitacao.gestorSolicitante.email)
                .then(response => {
                    if (response.data) {
                        this.solicitacao.contatoGlobo.id = response.data.id;
                        this.solicitacao.contatoGlobo.nome = response.data.nome;
                        this.solicitacao.contatoGlobo.email = response.data.email;
                    } else {
                         this.solicitacao.contatoGlobo.nome = this.solicitacao.gestorSolicitante.nome;
                         this.solicitacao.contatoGlobo.email = this.solicitacao.gestorSolicitante.email;
                     }
                })
                .catch(error => {
                    this.formErrorsStore.addError(error);
                    this.solicitacao.contatoGlobo.nome = this.solicitacao.gestorSolicitante.nome;
                    this.solicitacao.contatoGlobo.email = this.solicitacao.gestorSolicitante.email;
                    console.log(error);
                });
         }
    }

    resetContatoGlobo() {
        this.solicitacao.contatoGlobo = {
            nome: "",
            telefone: "",
            email: ""
        };
    }

    setCCDebitoByGestor() {
        this.solicitacao.centroCustoDebito = null;
        if (this.solicitacao.gestorSolicitante && this.solicitacao.localContratacaoId) {
            this.setCentroCustoDebito(this.solicitacao.gestorSolicitante.centroCusto);
        }
    }

    setFatoGerador(value) {
        this.solicitacao.fatoGeradorId = value;
        this.solicitacao.fatoGerador = getByAtribute(this.fatosGeradores, value, "id");
    }

    setPerfilRecurso(value) {
        this.solicitacao.perfilRecurso = value;
    }

    setProduto(value) {
        if (value)
        {
            this.solicitacao.produtoId = value;
            this.solicitacao.produto = getByAtribute(this.produtos, value, "id");
            
        }else{
            this.idProdutoSelecionado = null;
            this.solicitacao.produtoId = null;
            this.solicitacao.produto = {};
            //this.resetProduto();
        }
    }

    setCargo(value) {
        this.solicitacao.cargoId = value;
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo();
        this.validarCpfIndicacoes();
        if(value) {
            const cargo = this.cargos.filter(c => c && c.id === value)[0];
            if (cargo) {
                this.cargoSelecionado = {value: value, label: cargo.nome + " (" + value + ")"}
            } else {
                this.cargoSelecionado = {}
            }
        } else {
            this.cargoSelecionado = {}
        }

    }

    setMotivoContratacao(value) {
        this.solicitacao.motivoContratacao = value;

        if(value === "SUB") {
            this.obterCargoSubstituido = false;
            this.solicitacao.cargo = null;
            this.solicitacao.cargoId = null;
        }
    }

    setPrevisaoTrabalhoExterno(value) {
        this.solicitacao.previsaoTrabalhoExterno = value;
    }

    setJustificativaExcecao(value) {
        this.solicitacao.justificativaExcecao = value;
    }

    setCentroCustoDebito(value) {
        this.solicitacao.centroCustoDebito = value;
        this.solicitacao.gestoresArDebito = null;
        this.gestoresArDebito = null;
        this.carregarGestoresCentroCustoDebito();
    }

    setGestorAreaDebito(value, options) {
        this.solicitacao.gestorAreaDebito = null;
        if (options && options.length > 0) {
            //response.data.idAprovador = options[0].idAprovador;
            this.solicitacao.gestorAreaDebito = options[0];
            this.solicitacao.gestorAreaDebitoId = options[0].id;
        }
    }

    setLoadingIndicacao = (key, value) => {
        const loading = {};
        loading[key] = true;
        const indicacaoJaEstaEmLoading = _.find(this.loadingCpfIndicacao, loading);
        if (!indicacaoJaEstaEmLoading && value) {
            this.loadingCpfIndicacao.push(loading);
        } else if (indicacaoJaEstaEmLoading && !value) {
            _.remove(this.loadingCpfIndicacao, loading);
        }
    };

    isIndicacaoLoading = (key) => {
        const loading = {};
        loading[key] = true;
        return _.find(this.loadingCpfIndicacao, loading);
    };

    validarCpfIndicacoes(atualizarDados = true) {
        this.solicitacao.indicacoes.forEach((indicacao, index) => {
            this.validarUmCpfIndicacao(indicacao.cpf, indicacao.key, atualizarDados);
        })
    }

    verificaSeExisteCargoNoPcp(cargoId) {
        if (cargoId)
            this.solicitacaoService.verificaSeExisteCargoNoPcp(cargoId).then(response => {
                console.log(response.data);
                if (response.data && response.data.codigo !== 2 ) {
                    if (response.data && response.data.codigo !== 2 ) {
                        if( response.data.codigo === 0 )
                            this.existeCargoNoPcp = ["Cargo não encontrado no PCP. Favor solicitar o cadastro com o responsável do PCP."];
                        else if(response.data.codigo === 1)
                            this.existeCargoNoPcp = ["Favor verificar com responsável pelo PCP o erro na integração de dados de cargo."];
                        else
                            this.existeCargoNoPcp = [response.data.mensagem];
                    } else {
                        this.existeCargoNoPcp = [];
                    }
                    this.codigoErro = response.data.codigo;
                } else {
                    this.existeCargoNoPcp = [];
                }
            }).catch(error => {
                this.existeCargoNoPcp = ["Não conseguimos validar este cargo no PCP"];

                this.formErrorsStore.addError(error);
            })
    }

    validarUmCpfIndicacao(value, key, atualizarDados = true) {
        if (value) {
            const cargo = getByAtribute(this.cargos, this.solicitacao.cargoId, "id");
            const consultaCpf = {
                cpf: value,
                dataInicioContrato: this.solicitacao.momentDataInicio ? moment(this.solicitacao.momentDataInicio).format('DD/MM/YYYY') : null,
                nomeCargo: _.get(cargo, "nome"),
                propostaSalario: this.solicitacao.solicitacaoExcecao ? this.solicitacao.salarioExcecao : _.get(this.solicitacao.cargo, "salarioBase"),
                cargoId: this.solicitacao.cargoId,
                empresaGloboId: this.solicitacao.localContratacaoId,
                solicitacaoExcecao: this.solicitacao.solicitacaoExcecao,
                solicitacaoId: _.get(this.solicitacao,"id"),
                solicitacaoEttId: _.get(this.solicitacaoEtt,"idSolicitacaoEtt")
            };
            const indicacao = getByAtribute(this.solicitacao.indicacoes, key, "key");
            this.setLoadingIndicacao(key, true);
            this.motService.validarCpf(consultaCpf).then(response => {
                if (response.data != null) {
                    indicacao.nome = _.get(response.data, "dadosMot.nome", "") && atualizarDados ? response.data.dadosMot.nome : indicacao.nome;
                    indicacao.email = _.get(response.data, "dadosMot.email", "") && atualizarDados ? response.data.dadosMot.email : indicacao.email;
                    indicacao.telefone = _.get(response.data, "dadosMot.telefone", "") && atualizarDados ? response.data.dadosMot.telefone : indicacao.telefone;
                    indicacao.alertaValidacaoCPF = response.data.alertaValidacaoCPF;
                    indicacao.obstrucaoValidacaoCPF = response.data.obstrucaoValidacaoCPF;
                }
                this.setLoadingIndicacao(key, false);
            }).catch(error => {
                this.formErrorsStore.addError(error);
                this.setLoadingIndicacao(key, false);
                console.log(error);
            });
        }
    }

    setIndicacaoCpf(value, key) {
        const indicacao = getByAtribute(this.solicitacao.indicacoes, key, "key");
        indicacao.cpf = value;
        if (value.length === 11) {
            this.validarUmCpfIndicacao(value, key);
        } else {
            indicacao.alertaValidacaoCPF = [];
            indicacao.obstrucaoValidacaoCPF = [];
        }
    }

    limpaCamposIndicacao(key) {
        const indicacao = getByAtribute(this.solicitacao.indicacoes, key, "key")
        if (key) {
            indicacao.nome = "";
            indicacao.email = "";
            indicacao.telefone = "";
            indicacao.alertaValidacaoCPF = [];
            indicacao.obstrucaoValidacaoCPF = [];
        } else {
            this.solicitacao.indicacoes = this.solicitacao.indicacoes.map(indicacao => {
                indicacao.cpf = "";
                indicacao.nome = "";
                indicacao.email = "";
                indicacao.telefone = "";
                indicacao.alertaValidacaoCPF = [];
                indicacao.obstrucaoValidacaoCPF = [];
                return indicacao;
            })
        }
    }

    setIndicacaoNome(value, index) {
        this.solicitacao.indicacoes[index].nome = value;
    }

    setIndicacaoETTId(value, index) {
        this.solicitacao.indicacoes[index].ettId = value;
    }

    setIndicacaoEmail(value, index) {
        this.solicitacao.indicacoes[index].email = value;
    }

    setIndicacaoTelefone(value, index) {
        this.solicitacao.indicacoes[index].telefone = value;
    }

    setContatoGloboNome(value) {
        this.solicitacao.contatoGlobo.nome = value;
    }

    setContatoGloboTelefone(value) {
        this.solicitacao.contatoGlobo.telefone = value;
    }

    setContatoGloboEmail(value) {
        this.solicitacao.contatoGlobo.email = value;
    }

    setMatriculaEmpregadosSubstituidos(value, index) {
        let matricula = value;
        if (value && typeof value === "object") {
            matricula = value.value;
        }
        if (matricula === null || matricula === undefined) {
            matricula = "";
        }
        this.solicitacao.matriculaEmpregadosSubstituidos[index] = String(matricula);
        if (!this.verificarobterCargoSubstituido()) {
            this.obterCargoSubstituido = false;
            this.solicitacao.cargo = null;
            this.solicitacao.cargoId = null;
        }

        let empregados = this.solicitacao.matriculaEmpregadosSubstituidos.filter(e => e !== null && e !== "");
        if(empregados === null || empregados.length === 0)
            this.setCargo(null);
    }

    verificarCargoPresente(matricula){
        let empregadosFiltrados;
        if(typeof matricula === "string") {
            empregadosFiltrados = this.empregadosFiltrados.filter( elem => (elem.matricula == matricula || elem.cpf == matricula));
        } else {
            empregadosFiltrados = this.empregadosFiltrados.filter( elem => (elem.matricula == matricula.value));
        }
        if(empregadosFiltrados != undefined && empregadosFiltrados[0] != undefined) {
            if (!(empregadosFiltrados[0].nh && (empregadosFiltrados[0].nh === "EQUIPE" || empregadosFiltrados[0].nh === "TEC/OPER") )) {
                if(empregadosFiltrados[0].nh === ""){
                    const mensagem = "O cargo do empregado não foi obtido. Favor verificar no HCM.";
                    return (<Alerta id={"empregadoSub" + empregadosFiltrados.matricula} alertas={[mensagem]}
                                    isBloqueante/>);
                } else {
                    const mensagem = "O cargo \"*\" do empregado não é elegível a MOT".replace("*", empregadosFiltrados[0].cargo.nome)
                    return (<Alerta id={"empregadoSub" + empregadosFiltrados.matricula} alertas={[mensagem]}
                                    isBloqueante/>);
                }
            }
        }
    }

    verificarobterCargoSubstituido(){
        this.cargoNaoPresente = false;
        let value  = this.solicitacao.matriculaEmpregadosSubstituidos[0];
        if(typeof value === "object") {
            value = value.value;
        }

        let empregadosFiltrados = this.empregadosFiltrados.filter( elem => (elem.matricula == value || elem.cpf == value));

        if(empregadosFiltrados[0] !== undefined && empregadosFiltrados[0] !== null && empregadosFiltrados[0].cargo !== null && !this.cargoSelecionado.value){
            this.cargoService.listByPrefixoNome(empregadosFiltrados[0].cargo.nome).then(response =>{
                this.cargos = response.data;

                if(value){
                    if(value && this.solicitacao.localContratacaoId && (empregadosFiltrados.length != 0)) {
                        const codCargo = empregadosFiltrados[0].cargo.id
                        if (codCargo) {
                            this.obterCargoSubstituido = true;
                            this.setCargo(codCargo);
                            this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo()
                            return true;
                        } else {
                            this.cargoNaoPresente = empregadosFiltrados[0].cargo.nome;
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else return this.solicitacao.motivoContratacao !== "SUB";
            }).catch(error =>{
                console.log(error);
                return false;
            })
        } else {
            return empregadosFiltrados[0] !== undefined && empregadosFiltrados[0] !== null; //Significa que o cargo ja foi escolhido
        }

    }

    setMatriculaAprovadoresExtra(value, options, index) {
        this.solicitacao.matriculaAprovadoresExtra[index] = value;
        this.solicitacao.optionAprovadoresExtra[index] = options[0];
    }

    cancelar = () => {
        return this.tarefaService.tramitar(this.taskAjustId, this.definicaoFluxoId, this.solicitacao.id, "CANCELAR", null, this.observacoes, this.detalhesTarefa);
    };

    /* cadastrarProdutoEbsSelecionado = () => {
        const persistEbsProduct = (motProduct) =>
        {
            // 204 No-Content
            if (motProduct.status == 204)
            {
                const fakeMotProduct =
                {
                    id: undefined,
                    codigo: this.solicitacao.produto.codigo,
                    nome: this.solicitacao.produto.descricaoMot.substring(0, 64),
                    justificativaContratacaoId: "",
                    justificativaContratacao: {
                        id: 0,
                        nome: ""
                    },
                    descricaoMot: this.solicitacao.produto.descricaoMot,
                    sistemaAlocacao: "PCP",
                    ativo: false
                }

                // Adiciona e retorna um produto EBS no MOT, assim permitindo o resgate do ID do mesmo.
                this.produtoService.save(fakeMotProduct)
                    .then(saved =>
                    {
                        this.solicitacao.produtoId = toString(saved.data.id);
                        this.solicitacao.produto = saved.data;
                        this.idProdutoSelecionado = saved.data;
                    })
                    .catch((error) => this.formErrorsStore.addError(error));
            }
            else
            {
                this.solicitacao.produtoId = toString(motProduct.data.id);
                this.solicitacao.produto = motProduct.data;
                this.idProdutoSelecionado = motProduct.data;
            }
        };

        // Salva um produto EBS não registrado no MOT
        this.produtoService.findByCodigo(this.solicitacao.produto.codigo)
            .then((motProduct) => persistEbsProduct(motProduct))
            .catch((error) => { console.log(error); this.formErrorsStore.addError(error); });
    }; */

    enviar = () => {
        const solicitacaoForm = Object.assign({}, this.solicitacao);

        // Após enviar uma solicitação o produtoId esta sendo definido para undefined, não consegui encontrar o motivo. Isso funciona.
        solicitacaoForm.produtoId = this.solicitacao.produto.id;

        const indicacoesValidas = [];
        solicitacaoForm.indicacoes.map(indicacao => {
            if (indicacao.cpf) {
                return indicacoesValidas.push(indicacao);
            }
        });

        solicitacaoForm.indicacoes = indicacoesValidas;

        solicitacaoForm.matriculaEmpregadosSubstituidos = this.apenasMatriculaEmpregadosSubstituidosValidos;

        solicitacaoForm.matriculaAprovadoresExtra = [];
        this.solicitacao.optionAprovadoresExtra.map(option => {
            if (option && option.value != "") {
                let value = parseInt(option.value);
                if (solicitacaoForm.matriculaAprovadoresExtra.indexOf(value) == -1) {
                    solicitacaoForm.matriculaAprovadoresExtra.push(value);
                }
            }
        });

        var tramite = this.montarTramiteFluxo(null, "ENVIAR");
        if (this.isSolicitacaoDeAjuste){ 
            this.detalhesTarefa.solicitacao = solicitacaoForm;
            tramite.idTask = this.taskAjustId;
            tramite.tipoTarefa = "HT_SolicitacaoContratacao"
            return this.fluxoService.tramitarFluxo(tramite);
        } else
            return this.fluxoService.solicitarContratacao(tramite);
        
    };

    salvarRascunho() {
        const solicitacaoForm = Object.assign({}, this.solicitacao);

        solicitacaoForm.matriculaEmpregadosSubstituidos = this.apenasMatriculaEmpregadosSubstituidosValidos;
        solicitacaoForm.tipoGdv = solicitacaoForm.cargo ? solicitacaoForm.cargo.tipoGDV : null;

        if (solicitacaoForm.indicacoes) {
            const indicacoesValidas = [];
            solicitacaoForm.indicacoes.map(indicacao => {
                if (indicacao.cpf) {
                    return indicacoesValidas.push(indicacao);
                }
            });
            solicitacaoForm.indicacoes = indicacoesValidas;
        }

        return this.solicitacaoService.salvarRascunho(solicitacaoForm)
    }

    openModal(tipo, validateForm = true) {
        this.formStore.setSubmitted(true);
        this.formStore.setSubmitMensagemErro("");
        this.solicitacao.optionAprovadoresExtra = [];
        if (this.validacaoStore.isValidForm || !validateForm) {
            if (this.aprovadoresExtra && this.aprovadoresExtra.length > 0) {
                this.solicitacao.matriculaAprovadoresExtra = [];
                this.aprovadoresExtra.map(empregado => {
                    const cpf = empregado.cpf ? " (" + empregado.cpf + ")" : "";
                    this.solicitacao.optionAprovadoresExtra.push({
                        "value": empregado.matricula,
                        "label": empregado.matricula + " - " + empregado.nome + cpf
                    });
                    this.solicitacao.matriculaAprovadoresExtra.push(empregado.matricula);
                });
            } else {
                this.solicitacao.matriculaAprovadoresExtra = [""];
                this.solicitacao.optionAprovadoresExtra = [""];
            }
            this.modalStore.toggleModal(tipo);
        }
    }

    setTipoEmailContratacao(value) {
        this.tipoEmailContratacao = value; // Atualiza o observável que o Select usa (string)
        // Converte para número para o atributo oficial da solicitação (para o backend)
        if (value === null || value === undefined || value === '') {
            this.solicitacao.tipoEmailContratacao = null;
        } else {
            this.solicitacao.tipoEmailContratacao = Number(value);
        }
    }

    resetSolicitacao() {
        this.solicitacao = {
            "id": 0,
            "status": "",
            "solicitacaoExcecao": false,
            "percentualAche": 0,
            "salarioExcecao": "",
            "matriculaAprovadoresExtra": [""],
            "produtoId": "",
            "produto": {
                "id": 0,
                "nome": "",
                "descricaoMot": "",
                "sistemaAlocacao": "",
                "ativo": true,
                "justificativaContratacaoId": 0,
            },
            "fatoGeradorId": "",
            "fatoGerador": {
                "id": 0,
                "nome": "",
                "descricaoMot": "",
                "sistemaAlocacao": "",
                "ativo": true,
                "justificativaContratacaoId": 0,
                "justificativaContratacao": {
                    "id": 0,
                    "nome": "",
                    "motivoContratacao": "",
                    "classificacaoRisco": "",
                    "justificativaAlocavel": "",
                    "eventoImprevisivel": true,
                    "podeRenovar": true,
                    "podeAlterarJustificativa": true,
                    "possuiFatoGerador": true,
                    "produtoOracle": false,
                    "exigeAprovacaoDiretor": true,
                    "funcionariosSubstituidosMin": 0,
                    "funcionariosSubstituidosMax": 0,
                    "solicSubstituicaoDiasMin": 0,
                    "solicSubstituicaoDiasMax": 0,
                    "funcSubsSemAprovMax": 0,
                    "solicContratacaoDiasMin": 0,
                    "solicContratacaoDiasMax": 0,
                    "solicTerminoAnteDiasMin": 0,
                    "prorrogacaoDiasMin": 0,
                    "prorrogacaoDiasMax": 0,
                    "iniSolicIdealDiasMin": 0,
                    "iniSolicIdealDiasMax": 0,
                    "curtoIniSolicDiasMin": 0,
                    "curtoIniSolicDiasMax": 0,
                    "recursosSolicMotMin": 0,
                    "recursosSolicMotMax": 0,
                    "contRenovDiasMax": 0,
                    "substituicoesPermitidasMax": 0,
                    "renovPeriodoIniDiasMax": 0,
                    "renovPeriodoAdiDiasMax": 0,
                    "ativo": true,
                    "descricao": "",
                    "prorrogacoesPermitidasMax": 0
                }
            },
            "detalhamentoJustificativa": "",
            "dataInicio": "",
            "dataTermino": "",
            "quantidadeRecursos": null,
            "cargoId": "",
            "cargo": {},
            "perfilRecurso": "",
            "motivoContratacao": "",
            "justificativaContratacaoId": "",
            "justificativaContratacao": {
                "id": 0,
                "nome": "",
                "motivoContratacao": "",
                "classificacaoRisco": "",
                "justificativaAlocavel": "",
                "eventoImprevisivel": true,
                "podeRenovar": true,
                "podeAlterarJustificativa": true,
                "possuiFatoGerador": true,
                "produtoOracle": false,
                "exigeAprovacaoDiretor": true,
                "funcionariosSubstituidosMin": 0,
                "funcionariosSubstituidosMax": 0,
                "solicSubstituicaoDiasMin": 0,
                "solicSubstituicaoDiasMax": 0,
                "funcSubsSemAprovMax": 0,
                "solicContratacaoDiasMin": 0,
                "solicContratacaoDiasMax": 0,
                "solicTerminoAnteDiasMin": 0,
                "prorrogacaoDiasMin": 0,
                "prorrogacaoDiasMax": 0,
                "iniSolicIdealDiasMin": 0,
                "iniSolicIdealDiasMax": 0,
                "curtoIniSolicDiasMin": 0,
                "curtoIniSolicDiasMax": 0,
                "recursosSolicMotMin": 0,
                "recursosSolicMotMax": 0,
                "contRenovDiasMax": 0,
                "substituicoesPermitidasMax": 0,
                "renovPeriodoIniDiasMax": 0,
                "renovPeriodoAdiDiasMax": 0,
                "ativo": true,
                "descricao": "",
                "prorrogacoesPermitidasMax": 0
            },
            "contatoGloboId": 0,
            "contatoGlobo": {
                "id": 0,
                "nome": "",
                "telefone": "",
                "email": "",
                "tipo": ""
            },
            "previsaoTrabalhoExterno": true,
            "gestorSolicitanteId": 0,
            "gestorSolicitante": null,
            "usuarioSolicitanteId": 0,
            "usuarioSolicitante": {
                "id": 0,
                "nome": "",
                "login": "",
                "senha": "",
                "context": "",
                "token": {
                    "tokenBpm": "",
                    "token": ""
                }
            },
            "empregadosSubstituidos": [],
            "matriculaEmpregadosSubstituidos": [],
            "lotacaoId": "",
            "descricaoEpis": "",
            "localContratacaoId": "",
            "localContratacao": {
                "id": 0,
                "nome": "",
                "grupoSalarial": "",
                "codigoFpw": 0
            },
            "localTrabalhoId": "",
            "localTrabalhoCodigo": "",
            "localTrabalho": null,
            "indicacoes": [
                {
                    id: 0,
                    cpf: "",
                    nome: "",
                    ettId: "",
                    email: "",
                    telefone: "",
                    obstrucaoValidacaoCPF: [],
                    alertaValidacaoCPF: [],
                    key: shortid.generate()
                }
            ],
            "justificativaExcecao": "",
            "centroCustoDebito": "",
            "nomeAreaDebito": "",
            "centroCustoGestor": "",
            "nomeAreaResponsavel": "",
            "nomeCentral": "",
            "nomeDivisao": "",
            "nomeDepartamento": "",
            "gestorAreaDebitoId": null,
            "gestorAreaDebito": null,
            "nomeFluxo": "",
            "nomeTarefa": "",
            "responsavelTarefa": "",
            "prazoTarefa": "",
            "tipoEmailContratacao": null
        };


        extendObservable(this.solicitacao, {
            momentDataInicio: "",
            momentDataTermino: ""
        });
    }

    @computed
    get isCentroCustoDebitoMediaPulse() {
        return (this.targetCentroCustoDebito && this.targetCentroCustoDebito== "MEDIAPULSE");
    }

    @computed
    get isJustificativaCusteioDireto() {
        let justificativa = this.solicitacao.justificativaContratacao;
        let produtoOracle = justificativa ? justificativa.produtoOracle : null;

        return produtoOracle;
    }

    @computed
    get mensagemAlertaAlocacao() {

        let centroCustoDebito = this.solicitacao.centroCustoDebito;
        let codProduto = this.solicitacao.produto.codigo;
        let chaveContabil = centroCustoDebito + "-" + codProduto;
        let mensagem = null;

        let mensagemCusteioDireto = "Caso queira custear pelo projeto escolhido no SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'. "
        let mensagemCentroCusto = `O custeio mensal será realizado na chave contábil ${chaveContabil}.`


        if (this.isCentroCustoDebitoMediaPulse) {
            mensagem = isJustificativaCusteioDireto ? mensagemCentroCusto : mensagemCusteioDireto;
        } else {

        }

        return mensagem;
    }

    @computed
    get mensagemCentroCustoDebitoMediapulse() {
        let mensagem = "Este centro de custo segue regras de planejamento/alocação de recursos. Caso queira definir o custeio pelo SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'."
        return this.isCentroCustoDebitoMediaPulse ? mensagem : "";
    }

    @computed
    get isProdutoEditavel() {
        let mediaPulse = (this.targetCentroCustoDebito && this.targetCentroCustoDebito == "MEDIAPULSE");
        let editavel = (this.solicitacao.justificativaContratacao &&
            _.get(this.solicitacao, "justificativaContratacao.justificativaAlocavel") !== "NAO" &&
            !(!this.solicitacao.justificativaContratacao.produtoOracle && mediaPulse));
        return (this.produtos.length > 0 || (this.solicitacao.produto && this.solicitacao.produto.id)) && editavel;
        //return true;
    }

    // monta o dto de tramite. Relativo ao TramiteFluxoDTO do backend
    montarTramiteFluxo(idTask, acao){
        var tramite = {
            idTask: idTask,
            acao: acao,
            nomeFluxo: this.nomeFluxo,
            tipoFluxo: "solicitacaoContratacao",
            tipoTarefa: this.tipoTarefa,
            idSolicitacao: this.solicitacao.idSolicitacao,
            idSolicitacaoEtt: null,
            comentario: this.observacoes, 
            aprovadoresExtra: this.apenasMatriculaAprovadoresExtraValidos,
            dadosSolicitacao: this.solicitacao
        }
        return tramite
    }

}